// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input--2MxXS"};